import { Injector } from '@angular/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  defaultErrorConfigFormModel,
  errorCompnentFromSettingsFormModel,
  errorCompnentParseIntoSettingsFormModel,
  getAllGenericFetchFormFields,
} from '../custom-error.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomErrorComponentFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultErrorConfigFormModel;
    this.settingsFormlyForm = [
      {
        key: 'layout',
        type: EIremboFormlyFieldTypes.customdropdown,
        defaultValue: 'inline',
        props: {
          label: 'Layout',
          placeholder: 'Select layout',
          bindLabel: 'label',
          bindValue: 'value',
          options: [
            {
              value: 'inline',
              label: 'In Line',
            },
            {
              value: 'boxed',
              label: 'Boxed',
            },
          ],
        },
        expressions: {},
      },
      {
        key: 'errorKey',
        type: EIremboFormlyFieldTypes.customdropdown,
        props: {
          label: 'Generic Fetch Fields',
          required: true,
          placeholder: 'Select a generic fetch field associated to this error',
          bindLabel: 'label',
          bindValue: 'value',
          options: getAllGenericFetchFormFields(this.formBuilderService),
        },
      },
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return errorCompnentParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return errorCompnentFromSettingsFormModel(model, this.field);
  }

  protected override getValidationsConfig() {
    return undefined;
  }

  protected override getDisplayConfig() {
    return undefined;
  }
}
